exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppShell-Sidebar {\n  margin: 8px; }\n", ""]);

// exports
